import React, { useContext } from "react"
import styled from "styled-components"
import { rem } from "polished"
import Link from "gatsby-link"
import { Row, Col } from "react-flexbox-grid"
import Container from "../components/container"
import { motion, AnimatePresence } from "framer-motion"
import InlineSVG from "react-inlinesvg"

import { LoadedContext } from "./loaded-context"

import LogoUrl from "../assets/images/footer-logo.svg"
import { ReactComponent as Logo } from "../assets/images/supercontinental-logo.svg"

const FooterEl = styled.footer`
  padding: ${rem(45)} 0 ${rem(56)} 0;
  color: #fff;
  width: 100%;

  svg {
    height: auto;
    color: #c6c5c6;
  }

  @media ${props => props.theme.mobileDown} {
    // padding: 0 0 ${rem(56)} 0;
    padding: 0 0 ${rem(20)} 0;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  .logo {
    display: block;
    margin-top: 0;
    width: 50%;
    margin-bottom: 3px;
    height: auto;

    @media ${props => props.theme.desktopDown} {
      width: 80%;
    }
  }

  p {
    line-height: 1.2;
  }

  svg {
    width: 100%;
    display: block;
    margin-top: -20px;

    @media ${props => props.theme.mobileDown} {
      margin-top: 0;
      margin-bottom: ${rem(10)};
    }
  }
`

const StyledCol = styled(Col)`
  @media ${props => props.theme.mobileDown} {
    line-height: 1.5;

    &:nth-of-type(1) {
      order: 1;
    }

    &:nth-of-type(2) {
      order: 3;
    }

    &:nth-of-type(3) {
      order: 2;
    }

    &:nth-of-type(4) {
      order: 4;
    }

    &:nth-of-type(5) {
      order: 5;
    }

    &:nth-of-type(6) {
      order: 2;
    }
  }
`

const LogoCol = styled(StyledCol)`
  @media ${props => props.theme.desktopDown} {
    display: none;
  }

  @media ${props => props.theme.mobileDown} {
    display: block;
  }
`

const Footer = props => {
  const loadedContext = useContext(LoadedContext)

  return (
    <AnimatePresence>
      {props.layout !== "no-footer" ? (
        <motion.div
          initial={{ opacity: 0 }}
          animate={loadedContext.loaded && { opacity: 1 }}
        >
          <FooterEl>
            <Container>
              <Row>
                <StyledCol lg={3} lgOffset={1} md={3}>
                  {/* <InlineSVG className="logo" src={Logo} alt="Supercontinent" /> */}
                  <Logo className="logo" />

                  <p>{props.footerAddress}</p>
                </StyledCol>

                <StyledCol lg={2} xs={7} md={2}>
                  <p>
                    <Link to="/imprint">Imprint</Link>
                  </p>
                </StyledCol>

                <StyledCol lg={2} md={3}>
                  <p>
                    {props.footerContactInformation.map((item, index) => (
                      <React.Fragment key={index}>
                        {item.footerContactInformationContact.includes("@") && (
                          <React.Fragment>
                            <a
                              href={`mailto:${item.footerContactInformationContact}`}
                            >
                              {item.footerContactInformationContact}
                            </a>{" "}
                            <br />
                          </React.Fragment>
                        )}

                        {item.footerContactInformationContact.includes("+") && (
                          <React.Fragment>
                            <a
                              href={`tel:${item.footerContactInformationContact}`}
                            >
                              {item.footerContactInformationContact}
                            </a>{" "}
                            <br />
                          </React.Fragment>
                        )}
                      </React.Fragment>
                    ))}
                  </p>
                </StyledCol>

                <StyledCol lg={1} xs={3} md={2}>
                  <p>
                    <a
                      href={props.footerInstagramUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Instagram
                    </a>
                  </p>
                </StyledCol>

                <StyledCol lg={1} xs={2} md={2}>
                  <p>
                    <a
                      href={props.footerVimeoUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Vimeo
                    </a>
                  </p>
                </StyledCol>

                <LogoCol lg={1} xs={3} xsOffset={9} lgOffset={0}>
                  <InlineSVG src={LogoUrl} />
                </LogoCol>
              </Row>
            </Container>
          </FooterEl>
        </motion.div>
      ) : (
        <motion.div></motion.div>
      )}
    </AnimatePresence>
  )
}

export default Footer
